import React,{useState, useEffect}  from 'react';
import Table from 'react-bootstrap/Table';
import Sides from '../Bars/Csidebar';
import { Helmet } from "react-helmet";
import Button from 'react-bootstrap/Button'
function Ckeyword(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
return(
    <div>
       <Sides/>
       <Helmet>
 
 <title>C keyword tutorial For Beginners</title>
 <meta name="description" content="C keyword tutorial for beginners.There are 32 Types of Keyword in C Programming Language. CodeExampler provides Multiple Programming Examples for Beginners,CodeExampler provides Free Online Tutorials for beginners" />
 <meta name="keywords" content="codeexampler,programming language,tutorial for begineers,learn code in free,c programming tutorial for beginners,learn code in free online,c keyword,c keyword extern,c keyword static,c keywords,c keyword volatile,volatile keyword c,c define keyword,c final keyword,c language keywords list,how many keyword in c language,c keywords and identifiers" />
 <link rel="canonical" href="https://www.codeexampler.com/c-keyword" />
 </Helmet>

 <div className='lg:pl-56'>


    <h1 className="m-4 mh1">C keywords</h1>
    <div className="first">
        <a href="/c-element">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/c-identifier">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    <h2 className="mt-4 mh2"> C Keyword in Programming Language</h2>
<p className="mt-4 para">1,There are 32 types of keywords in C Programming Language.<br/>
2, C keywords are Known as Reserved Words.<br/>
3, These Keywords are Not used in Variable Name Means These keywords cannot use as identifiers. They cannot use as names for a variable, class, or method.</p>
  <h2 className="mt-4 mh2">C Programming Keyword Table</h2>
    <Table striped bordered hover responsive variant="dark m-4">
  <thead>
    <tr>
      <th></th>
      <th>auto</th>
      <th>double</th>
      <th>int</th>
      <th>struct</th>
    </tr>
  </thead> 
  <tbody>
    <tr>
      <td></td>
      <td>break</td>
      <td>char</td>
      <td>continue</td>
      <td>case</td>
    
    </tr>
    <tr>
      <td></td>
      <td>const</td>
      <td>else</td>
      <td>float</td>
      <td>goto</td>
      
    </tr>
    <tr>
      <td></td>
      <td>default</td>
      <td>do</td>
      <td>enum</td>
      <td>if</td>
      
    </tr>

    <tr>
      <td></td>
      <td>for</td>
      <td>extern</td>
      <td>long</td>
      <td>return</td>
      
    </tr>

    <tr>
      <td></td>
      <td>sizeof</td>
      <td>static</td>
      <td>signed</td>
      <td>register</td>
     
    </tr>

    <tr>
      <td></td>
      <td>short</td>
      <td>switch</td>
      <td>union</td>
      <td>void</td>
      
      
    </tr>

    <tr>
      <td></td>
      <td>unsigned</td>
      <td>volatile</td>
      <td>while</td>
      <td>typedef</td>
      
    </tr>

  </tbody>
</Table>
<h1 className="mt-5">  </h1>
<div className="back">
        <a href="/c-element">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/c-identifier">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    </div></div>
)

}
export default Ckeyword;